import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const TimelineWrapper = styled.div`
    width: 100%;
    height: ${({ bannerMargin }) =>
        bannerMargin
            ? `calc(100vh - 10.125rem - ${bannerMargin})`
            : 'calc(100vh - 10.125rem)'};
    display: flex;
    justify-content: center;
    ${media.mediumDevice`
    height: ${({ bannerMargin }) =>
        bannerMargin
            ? `calc(100vh - 11.125rem - ${bannerMargin})`
            : 'calc(100vh - 11.125rem)'};
    `}
    ${media.smalDevice`
    height: ${({ bannerMargin }) =>
        bannerMargin
            ? `calc(100vh - 10.125rem - ${bannerMargin})`
            : 'calc(100vh - 10.125rem)'};
    `}
`;

export const TimelineContainer = styled.div`
    font-family: AvenirNextWorld Regular;
    /* margin: 0 15px 0 15px; */
    box-shadow: 0px 0px 6px #00000029;
    background: #ffff;
    border-radius: 9px;
    padding: 20px 11px 2px 15px;
    display: flex;
    flex-direction: column;
    height: 90%;
    /* min-width: 1247px; */
    width: 100%;
    justify-self: center !important;

    ${media.mediumDevice`
          height: 88%;
     `}
`;

export const WeekdayHeader = styled.div`
    position: sticky;
    top: 0;
    z-index: 10;
    min-height: 38px !important;
    width: fit-content;
    display: flex;
    flex-direction: row;
    background-color: #ffff;
    opacity: 1;
    align-items: flex-end;
`;

export const WeekDayIndicator = styled.div`
    height: 100%;
    width: 148.87px !important;
    margin-right: 4px;
    position: relative;
    background: ${(props) =>
        props.background
            ? props.background
            : '#F5F5F5CC 0% 0% no-repeat padding-box'};
    border: ${(props) => (props.border ? props.border : '1px solid #E5E5E5')};
    border-radius: 6px 6px 0px 0px;
    opacity: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    &:hover {
        cursor: pointer;
    }
`;

export const CaseListingContainer = styled.div`
    min-height: 20px;
    width: 100%;
    /* min-width: 1220px !important; */
    /* background-color: cyan; */
    display: flex;
    flex-direction: row;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    z-index: 1;
    flex: 1;

    @media (min-width: 1025px) and (max-width: 1280px) {
        min-width: 1071px;
        overflow-x: auto;
    }

    ${media.mediumDevice`
		min-width:1071px;
        overflow-x: scroll !important;
	`}

    /* ${media.smalDevice`
		min-height:760px;
        overflow-y: scroll !important;
         overflow-x: scroll !important;
	`} */
`;

export const ListingMain = styled.div`
    border-top: 11px solid #ffff;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
    overflow-x: scroll !important;
    flex: 1;
    height: 100%;
    &::-webkit-scrollbar {
        display: none;
    }
    ${media.mediumDevice`
        background: transparent linear-gradient(90deg, #F9F9F93B 78%, #CACACA9B 100%, #808080BC 135%) 0% 0% no-repeat padding-box;
        height: 100%;
        ${scrollBarStyle}
        &::-webkit-scrollbar:horizontal {
            display: block;
        }
	`}/* ${media.smalDevice`
        overflow-y: hidden !important ;
        overflow-x: scroll !important;
	`} */
`;

export const TextBold = styled.div`
    font-family: AvenirNextWorld Bold;
    font-size: ${(props) => props.fontSize};
`;
export const TextRegular = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: ${(props) => props.fontSize};
`;
export const TextDemi = styled.div`
    font-family: AvenirNextWorld Demi;
    font-size: ${(props) => props.fontSize};
    margin: ${(props) => props.margin};
`;
export const StyledWeekDate = styled.div`
    position: absolute;
    right: 10px;
`;
